/**
 * Removes all non-digit characters from a phone number.
 *
 * @param phoneNumber - The phone number to clean.
 * @returns The cleaned phone number.
 */
export const cleanPhone = (phoneNumber: string): string => {
  return phoneNumber.replace(/\D/g, '');
};
